import type React from 'react';

import { consultationStatus, useConsultation } from '@entities/consultations';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { useModalCopyMessage } from '@features/common';
import {
	useCancelConsultation,
	useConnect,
	useConsultationMessage,
	useDeleteConsultation,
} from '@features/consultations';

import { MoreHoriz } from '@shared/assets';
import { useMuiMenu } from '@shared/hooks';
import { IconButton } from '@shared/ui';

type Props = {
	id: number;
};

export const SellerMenu: React.FC<Props> = ({ id }) => {
	const { isOpen, onOpen, onClose, anchorEl } = useMuiMenu();
	const { consultation } = useConsultation(id);
	const { onConnect } = useConnect(id);
	const { message } = useConsultationMessage(id);
	const { toggleCopyModal } = useModalCopyMessage();
	const { onCancel } = useCancelConsultation(id);
	const { onDelete } = useDeleteConsultation(id);

	const status = consultationStatus(consultation);

	return (
		<>
			<IconButton
				id="program-card-button"
				aria-controls={isOpen ? 'program-card-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={isOpen ? 'true' : undefined}
				onClick={onOpen}
				variant="transparent"
			>
				<MoreHoriz />
			</IconButton>
			<Menu
				id="program-card-menu"
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={isOpen}
				onClose={onClose}
				onBlur={onClose}
				MenuListProps={{
					'aria-labelledby': 'program-card-button',
				}}
			>
				{status === 'notPayed' && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							toggleCopyModal(message);
						}}
					>
						Оповестить об оплате
					</MenuItem>
				)}

				{status === 'confirmed' && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							onConnect();
						}}
					>
						Подключиться
					</MenuItem>
				)}

				{status === 'confirmed' && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							onCancel();
						}}
					>
						Отменить
					</MenuItem>
				)}

				{status === 'cancelled' && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							onDelete();
						}}
					>
						Удалить
					</MenuItem>
				)}
			</Menu>
		</>
	);
};
